import history from '../../../../../history';
import {
  actionCreator,
  AgencyActionTypes,
  CHECK_AGENCYEXIST,
  checkHttpStatus,
  GET_AGENCYDATABYID,
  GET_AGENCYLIST,
  GET_MASTERDATABYNAME,
  jsonApiHeader,
  POST_AGENCYDATA,
  showSuccessMessage,
  createSearchUrlForCustomAPI,
} from '../constants/ApiConstants';
import { showErrorMessage } from '../../../../scheduling/constants/ApiConstants';
import { checkHttpStatusAuthCheck } from '../../../../../actions/utilAction';


export const getMasterData = (masterDataList) => {

  return (dispatch, getState) => {

    dispatch(actionCreator(AgencyActionTypes.get_master_data.REQUEST));
    fetch(`${GET_MASTERDATABYNAME}`, {
      method: 'post',
      body: JSON.stringify({ 'masterdata': 'maritalStatus,mastercountry,masterstate,ORGANIZATIONDATABASEDETAIL' }),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        dispatch(actionCreator(AgencyActionTypes.get_master_data.SUCCESS, response));
      })
      .catch(function(error) {

      });
  };
};

// export const getAgencyBySearchText = (searchObj) => {
//   return (dispatch, getState) => {
//     dispatch(actionCreator(AgencyActionTypes.get_Agency_BySeachText.REQUEST));
//     let query_params = createSearchUrl(searchObj);
//     fetch(`${GET_AGENCYLIST}${query_params}`, {
//       method: 'get',
//       headers: jsonApiHeader(getState().login.access_token, 'application/json'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {
//         dispatch(actionCreator(AgencyActionTypes.get_Agency_BySeachText.SUCCESS, response));
//       })
//       .catch(function(error) {
//         console.log(error);
//       });
//   };
// };


export const getAgencyList = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(AgencyActionTypes.get_Agency.REQUEST));
    let query_params = createSearchUrlForCustomAPI(searchObj);
  //  console.log('${GET_AGENCYLIST}${query_params}.........', `${GET_AGENCYLIST}${query_params}`);
    fetch(`${GET_AGENCYLIST}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response.........', response);
        dispatch(actionCreator(AgencyActionTypes.get_Agency.SUCCESS, response));
      })
      .catch(function(error) {
        console.log(error);
      });
  };
};


export const getAgencyDataById = (agencyId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(AgencyActionTypes.get_Agency_byId.REQUEST));
    // console.log('Full URL.........', GET_AGENCYDATABYID + '?Id=' + agencyId);
    fetch(`${GET_AGENCYDATABYID}?Id=${agencyId}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response.........', response);
        dispatch(actionCreator(AgencyActionTypes.get_Agency_byId.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error get agency by ID action', error);
      });
  };
};

export const isAgencyExist = (businessName) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(AgencyActionTypes.check_agency_name.REQUEST));
    // console.log('Full URL.........', GET_AGENCYDATABYID + '?Id=' + agencyId);
    fetch(`${CHECK_AGENCYEXIST}?BusinessName=${businessName}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response.........', response);
        dispatch(actionCreator(AgencyActionTypes.check_agency_name.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error check agency name exist action', error);
      });
  };
};

// export const asyncValidate = (formData) => {debugger
//   // return (dispatch, getState) => {
//   // dispatch(actionCreator(AgencyActionTypes.check_agency_name.REQUEST));
//   return new Promise((resolve) => {
//     fetch(`${CHECK_AGENCYEXIST}?OrganizationName=${formData.OrganizationName}`, {
//       method: 'GET',
//       headers: jsonApiHeader('application/json'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {debugger
//         // dispatch(actionCreator(AgencyActionTypes.check_agency_name.SUCCESS, response));
//         if (response.data) {
//           throw { OrganizationName: 'Agency name already exist, please choose another.' };
//         }
//       })
//       .catch(function(error) {
//         console.log('error check agency name exist action', error);
//       });
//   });
// };

  // save agency details ...
export const saveAgencyData = (formData) => {

  return (dispatch, getState) => {
    dispatch(actionCreator(AgencyActionTypes.post_agency_data.REQUEST));
    let requestType = 'post';
    let postApi = `${POST_AGENCYDATA}`;
    let postData = JSON.stringify(formData);
    // console.log('postData .....', postData, 'postApi .....', postApi);
    fetch(postApi, {
      method: requestType,
      body: postData,
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response) {
          // console.log(response);
          if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
            showSuccessMessage(response.message);
            dispatch(actionCreator(AgencyActionTypes.post_agency_data.SUCCESS, response));
            history.push('/webadmin/agency');
          } else {
            showErrorMessage(response.message);
            dispatch(actionCreator(AgencyActionTypes.post_agency_data.SUCCESS, {}));
          }
        }
      })
      .catch(function(error) {
        showErrorMessage('Oops, something went wrong, please try later.');
        console.log(error);
      });
  };
};


export const deleteAgencyData = (agencyId) => {

  // return (dispatch, getState) => {
  //   dispatch(actionCreator(AgencyActionTypes.delete_agency_data.REQUEST));
  //   fetch(`${SUPERADMIN_AGENCY}/${agencyId}`, {
  //     method: 'delete',
  //     headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
  //   })
  //     .then(checkHttpStatus)
  //     .then(function(response) {
  //       Alert.success('Agency has been deleted successfully', {
  //         position: 'bottom-right',
  //         effect: 'slide',
  //       });
  //       dispatch(actionCreator(AgencyActionTypes.delete_agency_data.SUCCESS, response));
  //       let searchObj = {
  //         sort_fields: '-id',
  //         // page_number: page_number ? page_number : 1,
  //         page_number: 1,
  //         includes: 'include=mastercountry,masterstate,organizationdatabasedetail',
  //       };
  //       dispatch(getAgencyList(searchObj));

  //     })
  //     .catch(function(error) {
  //       console.log(error);
  //     });
  // };
};




// WEBPACK FOOTER //
// ./src/modules/Superadmin/components/ManageAgency/actions/AgencyAction.js